import { Box, Container, Flex } from "@mantine/core";
import { createFileRoute, Outlet, useMatch } from "@tanstack/react-router";
import { groupBy } from "lodash";
import AdminDesktopNavbar from "../../../components/AdminNavbar/AdminDesktopNavbar";
import AdminMobileNavbar from "../../../components/AdminNavbar/AdminMobileNavbar";
import { useAdminMenuItems } from "../../../features/Layout/Header/components/ProfileDropdown/components/Dropdown/components/AdminMenu/AdminMenu";
import { requireAdminRole } from "../../../helpers/role.helpers";
import useIsMobile from "../../../hooks/useIsMobile";

export const Route = createFileRoute("/(app)/admin")({
  // Covers every /admin child route (see the inventory in quick 261004-ud2).
  beforeLoad: requireAdminRole,
  component: RouteComponent,
});

function RouteComponent() {
  const adminMenuItems = useAdminMenuItems();
  const itemGroups = groupBy(adminMenuItems, "groupIndex");
  const mobile = useIsMobile();
  const isTicketPage = !!useMatch({
    from: "/(app)/admin/tickets/$id/",
    shouldThrow: false,
  });

  return isTicketPage ? (
    <Outlet />
  ) : (
    <Flex>
      {!mobile && <AdminDesktopNavbar itemGroups={itemGroups} />}
      <Box style={{ flex: 1, minWidth: 0 }}>
        {mobile && <AdminMobileNavbar items={adminMenuItems} />}
        <Container fluid pr="sm" pt="md" w="100%">
          <Outlet />
        </Container>
      </Box>
    </Flex>
  );
}
